import {
  __,
  always,
  concat,
  pipe,
  prop,
  reverse,
  sortBy,
  uniqBy,
} from 'ramda'
import { createReducer } from '../../utilities/miscellaneous'

// events initial state
export const INITIAL_STATE = {
  isLoading: false,
  fetchError: false,
  canLoadMore: true,
  events: [],
  page: 1,
  limit: 20,
}

// events action types
export const CLEAN = 'article/events/CLEAN'
export const FETCH_EVENTS = 'article/events/FETCH_EVENTS'
export const RECEIVED_EVENTS = 'article/events/RECEIVED_EVENTS'
export const FETCH_ERROR = 'article/events/FETCH_ERROR'

// clean :: () ->  Action.CLEAN
export const clean = always({ type: CLEAN })

// fetchEvents :: () -> Action.FETCH_EVENTS
export const fetchEvents = page => ({
  type: FETCH_EVENTS,
  page,
})

// receivedEvents :: ([Event], Boolean) -> Action.RECEIVED_EVENTS
export const receivedEvents = (events, canLoadMore) => ({
  type: RECEIVED_EVENTS,
  events: events || [],
  canLoadMore,
})

// fetchError :: () -> Action.FETCH_ERROR
export const fetchError = always({ type: FETCH_ERROR })

// events :: (State, Action *) -> State
export default createReducer(INITIAL_STATE, {
  [CLEAN]: always(INITIAL_STATE),

  [FETCH_EVENTS]: (state, { page }) => ({
    ...state,
    isLoading: true,
    fetchError: false,
    page,
  }),

  [RECEIVED_EVENTS]: (state, { events, canLoadMore }) => ({
    ...state,
    isLoading: false,
    events: addEvents(state.events)(events),
    canLoadMore,
  }),

  [FETCH_ERROR]: state => ({
    ...state,
    isLoading: false,
    fetchError: true,
  }),
})

// addEvents :: [Event] -> [Event] -> [Event]
const addEvents = alreadyExistingEvents => pipe(
  concat(__, alreadyExistingEvents),
  uniqBy(prop('id')),
  sortBy(pipe(
    prop('date'),
    isoString => new Date(isoString),
    date => date.valueOf(),
  )),
  reverse,
)
